import Vue from 'vue';
import HkraftSoltak from './soltak.vue';

Vue.config.productionTip = false;

new Vue({
  el: 'hkraft-soltak',
  render(h) {
    return h(HkraftSoltak);
  },
});
